// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 535 ? "login" : chunkId) + "." + {"535":"7b2bd520","739":"60ac496b","787":"82d7896b"}[chunkId] + ".chunk.js";
};